var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex flex-col bg-white",
      class: {
        "fixed inset-0": _vm.fullscreen,
        "relative rounded-lg shadow-xl max-w-content max-h-full overflow-hidden overflow-y-auto": !_vm.fullscreen
      },
      attrs: {
        role: "dialog",
        "aria-labelledby": _vm.title && "modal-" + _vm.id + "-title",
        "aria-describedby": "modal-" + _vm.id + "-body"
      }
    },
    [
      _vm.title
        ? _c("div", { staticClass: "flex p-4 items-center" }, [
            _c(
              "h2",
              {
                staticClass: "font-semibold text-xl",
                attrs: { id: "modal-" + _vm.id + "-title" }
              },
              [_vm._v(" " + _vm._s(_vm.title) + " ")]
            ),
            _c("div", { staticClass: "flex-grow" }),
            _vm.options.cancellable
              ? _c(
                  "button",
                  {
                    staticClass: "p-2 ml-2 -my-2 rounded-lg hover:bg-gray-300",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.$ui.closeModal(_vm.id)
                      }
                    }
                  },
                  [
                    _c("BaseIcon", {
                      staticClass: "w-4 h-4 text-gray-800",
                      attrs: { name: "close" }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "flex flex-col flex-grow px-4",
          class: {
            "overflow-hidden": !_vm.scrollable,
            "pt-4": !_vm.title,
            "pb-4": !_vm.fullscreen,
            "pb-0": _vm.fullscreen,
            "overflow-y-scroll": _vm.fullscreen && _vm.scrollable
          },
          attrs: { id: "modal-" + _vm.id + "-body" }
        },
        [
          _vm._t("default"),
          _vm.fullscreen
            ? _c("div", { staticClass: "flex-shrink-0 h-4" })
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }